export default __webpack_public_path__ + "static/media/logo-BA-small.9644ce51.svg";